var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.action}},[_c('i',{staticClass:"collect",class:{'collected':_vm.isCollected},staticStyle:{"margin":"0 auto"}}),_c('span',[_vm._v(_vm._s(_vm.isCollected?"已收藏":"收藏"))])])}
var staticRenderFns = []

export { render, staticRenderFns }